import {useState} from 'react'
import {Content} from '../../../../_metronic/layout/components/content'
import {KTIcon} from '../../../../_metronic/helpers'
import SubMenuForm from './modal/SubMenuForm'
import SubmenuList from './SubmenuList'
import {ISubmenu} from './_model'
import InputSearchBox from '../../../utils/components/form/InputSearchBox'

const SubMenu = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedSubmenu, setSelectedSubmenu] = useState<ISubmenu | undefined>(undefined)

  const onSelectSubmenu = (submenu: ISubmenu) => {
    setSelectedSubmenu(submenu)
  }

  const onResetSelect = () => setSelectedSubmenu(undefined)

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center mb-3 gap-4 flex-wrap'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div>
          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={onResetSelect}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Create Submenu
          </button>
        </div>
      </div>

      <SubmenuList searchTerm={searchTerm} onSelectSubmenu={onSelectSubmenu} />

      <SubMenuForm selectedSubmenu={selectedSubmenu} onResetSelect={onResetSelect} />
    </Content>
  )
}

export default SubMenu
